var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.canlogin)?_c('login',{on:{"loginaction":_vm.updatelogin}}):_vm._e(),(_vm.canlogin)?_c('mainScreen',{on:{"loginaction":_vm.updatelogin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }